import { nowNextRequest, reportingRequest } from "./api.service";

/*************************************************/
/* METHODS */
/*************************************************/

/**
 * report
 *
 * @export
 * @param {any}
 * @returns Promise<response | error.response>
 */
export function report(reportData) {
  return new Promise((resolve, reject) => {
    reportingRequest(reportData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}

export function nowNext(radiostationUrl) {
  return new Promise((resolve, reject) => {
    nowNextRequest(radiostationUrl)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response);
      });
  });
}
